<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="来料入库" name="first">来料入库</el-tab-pane>
      <el-tab-pane label="领料出库" name="second">领料出库</el-tab-pane>
      <el-tab-pane label="成品入库" name="third">成品入库</el-tab-pane>
    </el-tabs>
    <ul v-if="activeName != 'third'" class="infinite-list" v-infinite-scroll="load" style="overflow:auto;color:#333333;width:100%;">
      <li v-for="(i, index) in data" :key="index" class="infinite-list-item">
        <div style="margin-left: 20px;margin-right: 20px;">
          <div style="display: flex;justify-content: space-between;flex-direction: row;">
            <div style="font-size: 16px;font-weight: 600;">Tracking NO：{{i.boxNo}}</div>
            <div style=" margin-top: -10px;">
              <el-button type="text" @click.native="showBtnAction(index)">{{data[index].show ? '收起' : '展开'}}</el-button>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;flex-direction: row;font-size: 14px;margin-top: 5px;">
            <div>库位：{{i.storePosition}}</div>
            <div>{{formatDate(i.updateAt)}}</div>
          </div>
          <div v-if="data[index].show">
            <div style="font-size: 14px;margin-top: 5px;">产品型号/芯片名称：{{i.incoOrdersDetail.product.productName}}/{{i.incoOrdersDetail.product.chipName}}</div>
            <div style="font-size: 14px;margin-top: 5px;">数量：{{Math.abs(i.count)}}</div>
            <div style="font-size: 14px;margin-top: 5px;">订单号：{{activeName === 'third' ? i.incoOrdersDetail.incoOrder.incoOrderNo : i.incoOrder.incoOrderNo}}</div>
            <div style="font-size: 14px;margin-top: 5px;">子批号：{{i.incoOrdersDetail.subNo}}</div>
            <div style="display: flex;justify-content: space-between;flex-direction: row;">
              <div style="font-size: 14px;margin-top: 5px;">印章号：{{i.lotNo}}</div>
              <div style=" margin-top: -10px;">
                <el-button type="text" @click.native="deleateAction(index)">删除</el-button>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </li>
    </ul>

    <ul v-if="activeName == 'third'" class="infinite-list" v-infinite-scroll="load" style="overflow:auto;color:#333333;width:100%;">
      <li v-for="(i, index) in data" :key="index" class="infinite-list-item">
        <div style="margin-left: 20px;margin-right: 20px;">
          <div style="display: flex;justify-content: space-between;flex-direction: row;">
            <div style="font-size: 16px;font-weight: 600;">Tracking NO：{{i.boxNo}}</div>
            <div style=" margin-top: -10px;">
              <el-button type="text" @click.native="showBtnAction(index)">{{data[index].show ? '收起' : '展开'}}</el-button>
            </div>
          </div>
          <div style="display: flex;justify-content: space-between;flex-direction: row;font-size: 14px;margin-top: 5px;">
            <div>库位：{{i.storePosition}}</div>
            <div>{{formatDate(i.updateAt)}}</div>
          </div>
          <div v-if="data[index].show">
            <hr />
            <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto;color:#333333;width:100%;">
              <li v-for="(j, index1) in i.infos" :key="index1" class="infinite-list-item">
                <div style="font-size: 14px;margin-top: 5px;">产品型号/芯片名称：{{j.productName}}/{{j.chipName}}</div>
                <div style="font-size: 14px;margin-top: 5px;">数量：{{Math.abs(j.count)}}</div>
                <div style="font-size: 14px;margin-top: 5px;">子批号：{{j.subNo}}</div>
                <div style="font-size: 14px;margin-top: 5px;">印章号：{{j.lotNo}}</div>
                <hr />
              </li>
            </ul>

            <div style="display: flex;justify-content: space-between;flex-direction: row;">
              <div style="font-size: 14px;margin-top: 5px;">总数量：{{i.count}}</div>
              <div style=" margin-top: -10px;">
                <el-button type="text" @click.native="deleateAction(index)">删除</el-button>
              </div>
            </div>
          </div>

        </div>
        <hr />
      </li>
    </ul>

    <button v-if="data.length" style="width: 100%;height: 40px;background-color: #FFFFFF;" @click="getMorelist()">加载更多</button>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="80%">
      <span>确认删除?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </span>
    </el-dialog>

  </div>


</template>

<script>
  import moment from 'moment';
  import {
    incoStorageOprList,
    incoStorageReturn,
    incoStorageCancelEntry
  } from '@/api/incoStorage';
  import {
    productsOprlistV2,
    cancelEntry
  } from '@/api/prodStorage';

  export default {
    data() {
      return {
        activeName: this.$route.params.activeName ? this.$route.params.activeName : 'first',
        data: [],
        show: 1,
        dialogVisible: false,
        index: 0,
        page: 1,
      };
    },
    mounted() {
      this.oprListGet(1, 200);
    },
    methods: {
      load() {

      },
      handleClick() {
        this.data = [];
        this.oprListGet(1, 200);
      },
      showBtnAction(index) {
        this.data[index].show = !this.data[index].show;
      },
      confirm() {
        if (this.activeName === 'first') {
          this.incoStorageCancelEntry(this.index);
        } else if (this.activeName === 'second') {
          this.incoStorageReturn(this.index);
        } else {
          this.cancelEntry(this.index);
        }
        this.dialogVisible = false;
      },
      deleateAction(index) {
        this.index = index;
        this.dialogVisible = true;
      },
      oprListGet() {
        let oprateType = 2;
        this.page = 1;
        if (this.activeName === 'first') {
          oprateType = 2;
        } else if (this.activeName === 'second') {
          oprateType = 3;
        } else {
          this.productsList(1);
          return;
        }
        this.incoStorageOprList(oprateType);
      },
      getMorelist() {
        let oprateType = 2;
        this.page++;
        if (this.activeName === 'first') {
          oprateType = 2;
        } else if (this.activeName === 'second') {
          oprateType = 3;
        } else {
          this.productsList(1);
          return;
        }
        this.incoStorageOprList(oprateType);
      },
      async incoStorageOprList(oprateType) {
        try {
          const res = await incoStorageOprList({
            page: this.page,
            perpage: 10,
            status: JSON.stringify([oprateType]),
          });
          if (this.page != 1) {
            this.data = this.data.concat(res.data.records)
          } else {
            this.data = res.data.records;
          }
          for (let i = 0; i < this.data.length; i++) {
            this.$set(this.data[i], 'show', false);
          }
        } catch (e) {
          // do nothing.
        }
      },
      async productsList(oprateType) {
        try {
          const res = await productsOprlistV2({
            page: this.page,
            perpage: 10,
            status: JSON.stringify([2]),
          });
          if (this.page != 1) {
            this.data = this.data.concat(res.data.records)
          } else {
            this.data = res.data.records;
          }
          for (let i = 0; i < this.data.length; i++) {
            this.$set(this.data[i], 'show', false);
          }
        } catch (e) {
          // do nothing.
        }
      },
      async incoStorageCancelEntry(index) {
        try {
          await incoStorageCancelEntry({
            boxNo: this.data[index].boxNo,
          });
          this.data.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除完成',
          });
        } catch (e) {
          // do nothing.
        }
      },
      async incoStorageReturn(index) {
        try {
          await incoStorageReturn({
            boxNo: this.data[index].boxNo,
          });
          this.data.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除完成',
          });
        } catch (e) {
          // do nothing.
        }
      },
      async cancelEntry(index) {
        try {
          await cancelEntry({
            boxNo: this.data[index].boxNo,
          });
          this.data.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除完成',
          });
        } catch (e) {
          // do nothing.
        }
      },
      formatDate(date) {
        const updateDate = moment.utc(date);
        return updateDate.local().format('YYYY-MM-DD HH:mm:ss');
      },
    },
  };
</script>

<style lang="less" scoped>
  .container {
    min-height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;

    .login-container {
      position: relative;
      width: 300px;
      max-width: 100%;
      padding: 30px;
      margin: auto;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }
  }
</style>
